import { useRoute, stringifyQuery } from 'vue-router';

//this component is used to refresh the page when the app_refresh query parameter is present in the URL
// and the value is not 'done'. It will refresh the page after the specified time in the app_refresh query parameter.

function ListenForPageRefresh() {
  // This function listens for the 'body_content_loaded' event and checks if the URL contains 'app_refresh'
  // If it does, it retrieves the app_refresh value and refreshes the page accordingly.

  const route = useRoute(); // Vue router route object

  document.addEventListener('body_content_loaded', function () {

    if (route.fullPath.includes('app_refresh')) {
      const appRefreshValue = route.query.app_refresh;

      if (appRefreshValue === 'done') {
        return; // Do not refresh if the app_refresh value is 'done'
      }

      const appRefreshTime = Number(appRefreshValue) || 0;

      route.query.app_refresh = 'done'; // Set the app_refresh value to 'done' to prevent infinite loop
      const newUrl = route.path + `?${stringifyQuery(route.query)}`; // Construct the new URL with the updated query parameter
      refreshPage(appRefreshTime, newUrl); // Call the refreshPage function with the new URL
    }
  });

}

function refreshPage(appRefreshTime: number, newUrl: string = '') {
    // Refresh the page after the specified time
    setTimeout(() => {
      window.location.href = newUrl; // Redirect to the same page with app_refresh=done
    }, appRefreshTime); 
}

export { ListenForPageRefresh };